import type {
  AttributesEntity,
  ValuesEntity,
} from '@eliadmin/core/src/api/products/types/product-types';
import { Checkbox } from '@eliadmin/core/src/components/ui/checkbox';
import { Label } from '@eliadmin/core/src/components/ui/label';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function AttributeCheckbox({
  attribute,
  updateVariantValues,
  className = '',
}: {
  attribute: AttributesEntity;
  updateVariantValues: (attribute: AttributesEntity, value: ValuesEntity) => void;
  className?: string;
}) {
  const attrId = attribute.id;
  const filter = useCategoryStore(state => state.filter.attributes);
  const valueAttribute = filter.find(item => item.id === attrId);
  const setFilter = useCategoryStore(state => state.setFilter);

  const sortedValues = [...(attribute.values ?? [])].sort(
    (a, b) => (a.position ?? 0) - (b.position ?? 0),
  );

  return (
    <div className={cn('flex flex-col gap-2', 'ea-attribute-checkbox', className)}>
      {sortedValues
        .filter(value => value.name)
        .map(value => (
          <div
            key={`attribute-${attrId}-value-${value.id}`}
            className={cn(
              'mr-2 flex flex-row items-center space-x-2',
              'ea-attribute-checkbox__input-wrapper',
            )}
          >
            <Checkbox
              id={`attribute-${attrId}-value-${value.id}`}
              name={`attribute-${attrId}-value-${value.id}`}
              checked={valueAttribute?.values.includes(value.id) ?? false}
              className={cn('', 'ea-attribute-checkbox__input')}
              onCheckedChange={() => {
                setFilter({ selectedValue: { attribute, value } });
                updateVariantValues(attribute, value);
              }}
            />
            <Label
              htmlFor={`attribute-${attrId}-value-${value.id}`}
              className={cn('', 'ea-attribute-checkbox__label')}
            >
              {value.name}
            </Label>
          </div>
        ))}
    </div>
  );
}
